import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    mapApiKey: String,
    latitude: Number,
    longitude: Number,
    img: String,
  };

  async connect() {
    const module = await import('../../admin/form/city');
    const AdminCityForm = module.AdminCityForm;

    const adminCityForm = new AdminCityForm(this.mapApiKeyValue, this.imgValue, this.latitudeValue, this.longitudeValue);
    adminCityForm.init().catch(console.error);
  }
}
